export const colors = {
    primary: {
        100: '#DBEFFF',
        200: '#A0CEE9',
        300: '#4193C1',
        400: '#0C547D',
        500: '#0A3454',
        600: '#002B4C',
        700: '#00213B'
    },
    secondary: {
        100: '#DAF7FF',
        200: '#A7DFF1',
        300: '#ACEBFF',
        400: '#80D5EF',
        500: '#5BADC7',
        600: '#3E91AC',
        700: '#246275'
    },
    success: {
        100: '#DCFAEC',
        200: '#84F1BE',
        300: '#21CF7E',
        400: '#0B8C50',
        500: '#077F47',
        600: '#046437',
        700: '#085E36'
    },
    warning: {
        100: '#FAEBD1',
        200: '#FDD269',
        300: '#FCBE37',
        400: '#F2A830',
        500: '#CA7E03',
        600: '#985F02',
        700: '#7A4006'
    },
    error: {
        100: '#FCE6E3',
        200: '#FFB6B9',
        300: '#FF8389',
        400: '#C01D0E',
        500: '#B01304',
        600: '#9A0E00',
        700: '#8C1207'
    },
    neutral: {
        100: '#F6F8F8',
        200: '#EDF1F3',
        300: '#BCC8CD',
        400: '#8298A1',
        500: '#607780',
        600: '#344146',
        700: '#141617'
    },
    // Legacy Colors; do not use.
    blue: {
        100: '#D3EFF8',
        200: '#A7DFF1',
        300: '#7BCEEA',
        400: '#49BDE4',
        500: '#23AEDC',
        600: '#1C8BB0',
        700: '#156884'
    },
    navy: {
        100: '#69ACC3',
        200: '#4797B2',
        300: '#1280BE',
        400: '#2A5969',
        500: '#1B3A45',
        600: '#002B4C',
        700: '#00213B'
    },
    green: {
        100: '#CFEACF',
        200: '#ACDAAC',
        300: '#89CA89',
        400: '#66BA66',
        500: '#4AA34A',
        600: '#3A803A',
        700: '#2A5D2A'
    },
    orange: {
        100: '#FDE19C',
        200: '#FDD269',
        300: '#FCC337',
        400: '#FBB405',
        500: '#CA9003',
        600: '#986D02',
        700: '#654902'
    },
    red: {
        100: '#FFE9EA',
        200: '#FFB6B9',
        300: '#FF8389',
        400: '#FF5058',
        500: '#C01D0E',
        600: '#E9000B',
        700: '#B60008'
    },
    gray: {
        100: '#F6F8F9',
        200: '#D9E0E3',
        300: '#BCC8CD',
        400: '#9FB0B7',
        500: '#8298A1',
        600: '#677F89',
        700: '#51646C'
    },
    boxShadow: '0 4px 16px rgba(159, 176, 183, 0.3)'
};
